import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { DM_Mono, Instrument_Sans, Instrument_Serif } from 'next/font/google'

const sans = Instrument_Sans({
    subsets: ['latin']
})

const heading = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const mono = DM_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
